export default __webpack_public_path__ + "static/media/wave.7a730115.svg";